import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0a0908]">
      <div className="max-w-[800px] mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <a
            href="/"
            className="inline-flex items-center gap-2 text-[#a6a196] hover:text-[#d4af37] transition-colors text-sm mb-8"
          >
            <ArrowLeft className="w-4 h-4" /> Kembali ke Beranda
          </a>

          <div className="flex items-center gap-3 mb-4">
            <div className="w-1 h-8 bg-[#d4af37] rounded-full" />
            <h1 className="font-display text-3xl sm:text-4xl text-[#fdfbf7] tracking-wide">
              Syarat & Ketentuan
            </h1>
          </div>
          <p className="text-sm text-[#a6a196] mb-12">
            Terakhir diperbarui: Juni 2026
          </p>
        </motion.div>

        <div className="space-y-10 text-[#a6a196] leading-relaxed">
          <Section title="1. Layanan">
            <p>
              Sanggar Rias Adibah menyediakan layanan jasa makeup profesional 
              untuk berbagai acara, termasuk tetapi tidak terbatas pada: 
              pernikahan (akad dan resepsi), lamaran, wisuda, bridesmaid, 
              keluarga, pemotretan, pesta, dan acara spesial lainnya.
            </p>
          </Section>

          <Section title="2. Reservasi dan Pembayaran">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Reservasi dilakukan melalui WhatsApp, email, atau formulir kontak di website</li>
              <li>Booking dianggap sah setelah pembayaran dp/booking fee diterima</li>
              <li>Sisa pembayaran dilunaskan pada hari acara atau sesuai kesepakatan</li>
              <li>Harga dapat berubah tanpa pemberitahuan sebelumnya, kecuali untuk reservasi yang sudah dikonfirmasi</li>
            </ul>
          </Section>

          <Section title="3. Pembatalan dan Refund">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Pembatalan 7+ hari sebelum acara: dp dikembalikan 50%</li>
              <li>Pembatalan 3-6 hari sebelum acara: dp tidak dapat dikembalikan</li>
              <li>Pembatalan kurang dari 48 jam: 100% biaya dikenakan</li>
              <li>Pembatalan dari pihak kami karena keadaan darurat: dp dikembalikan penuh atau dijadwalkan ulang</li>
            </ul>
          </Section>

          <Section title="4. Hak Cipta dan Penggunaan Foto">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Seluruh foto dan video yang diambil selama sesi makeup adalah hak cipta Sanggar Rias Adibah</li>
              <li>Kami berhak menggunakan foto-foto tersebut untuk keperluan portfolio, media sosial, iklan, dan promosi</li>
              <li>Jika klien tidak menginginkan fotonya dipublikasikan, wajib memberitahukan sebelum acara</li>
              <li>Klien tidak diperbolehkan mengedit atau memanipulasi foto yang telah diberikan</li>
            </ul>
          </Section>

          <Section title="5. Kewajiban Klien">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Hadir tepat waktu sesuai jadwal yang telah disepakati</li>
              <li>Melakukan perawatan kulit dasar sebelum sesi makeup</li>
              <li>Menyampaikan jika memiliki alergi atau kondisi kulit tertentu</li>
              <li>Menyediakan akses lokasi yang memadai untuk persiapan makeup</li>
            </ul>
          </Section>

          <Section title="6. Batasan Tanggung Jawab">
            <p>
              Sanggar Rias Adibah tidak bertanggung jawab atas:
            </p>
            <ul className="list-disc pl-5 space-y-1.5 mt-3">
              <li>Reaksi alergi yang tidak diberitahukan sebelumnya oleh klien</li>
              <li>Kerusakan makeup akibat faktor eksternal (hujan, keringat berlebih, gesekan) setelah sesi selesai</li>
              <li>Keterlambatan yang disebabkan oleh force majeure</li>
            </ul>
          </Section>

          <Section title="7. Kontak">
            <div className="space-y-1">
              <p>Email: lw5051900@gmail.com</p>
              <p>WhatsApp: +62 812 8032 7569</p>
              <p>Alamat: Perum Telaga Pesona Blok L26 No.3, Cikarang Barat, Bekasi</p>
            </div>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="font-serif text-xl sm:text-2xl text-[#fdfbf7] mb-4 font-light">
        {title}
      </h2>
      <div className="text-sm leading-relaxed space-y-2">
        {children}
      </div>
    </motion.div>
  );
}
